module.exports = __webpack_public_path__ + "images/e72d1907bf5d0f6c1153e50aa7cf7f9a.png";